{
	"type": "circle",
	"minzoom": 6,
	"layout": {},
	"paint": {
		"circle-color": "#555",
		"circle-opacity": 0.9,
		"circle-radius": ["interpolate", ["linear"], ["zoom"], 5, 0.8, 6, 4]
	}
}
